/* Occasional emphasis on one visible locality, scoped to the test section. */
(()=>{
 const key='m24AreaHighlight';if(window[key])return;window[key]=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');let active,lastName='';
 const clear=()=>{if(active)active.classList.remove('m24-area-highlight');active=null};
 const tick=()=>{
  clear();if(reduced.matches||document.hidden)return;
  const marquee=document.querySelector('.m24-area-marquee');if(!marquee||marquee.matches(':hover,:focus-within'))return;
  const rect=marquee.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
  const candidates=[...marquee.querySelectorAll('li')].filter(item=>{
   const box=item.getBoundingClientRect(),row=item.closest('.m24-area-row').getBoundingClientRect();
   return box.left>=row.left+28&&box.right<=row.right-28&&item.textContent!==lastName;
  });
  if(!candidates.length)return;
  active=candidates[Math.floor(Math.random()*candidates.length)];lastName=active.textContent;
  active.classList.add('m24-area-highlight');setTimeout(clear,2200);
 };
 setInterval(tick,7500);
 reduced.addEventListener('change',clear);document.addEventListener('visibilitychange',clear);
 document.addEventListener('pointerover',event=>{if(event.target.closest('.m24-area-marquee'))clear()});
 document.addEventListener('focusin',event=>{if(event.target.closest('.m24-area-marquee'))clear()});
})();
